export default __webpack_public_path__ + "static/media/bh.16f3550b.svg";